import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'

@Component({
  selector: 'one-copy-text-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  template: `
    <div class="copy-modal">
      <div class="modal-header">
        <h2>{{ data.title }}</h2>
        <span class="close-button" mat-dialog-close>&times;</span>
      </div>
      <div class="copy-content">
        <div class="copyable-text" (click)="copyToClipboard(data.text)">
          <span class="text" [title]="data.text">{{ data.text }}</span>
          <div class="copy-icons">
            <img src="/app_assets/copy-icon.png" alt="copy" class="copy-icon">
            <img src="/app_assets/checkmark-icon.png" alt="done" class="check-icon">
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .copy-modal {
      padding: 24px;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    h2 {
      margin: 0;
    }

    .close-button {
      cursor: pointer;
      font-size: 24px;
      line-height: 1;
    }

    .copy-content {
      .copyable-text {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: #f5f5f5;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          background: #eeeeee;
          .copy-icons .copy-icon {
            opacity: 1;
          }
        }
      }

      .text {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .copy-icons {
        position: relative;
        width: 16px;
        height: 16px;

        img {
          position: absolute;
          width: 16px;
          height: 16px;
          transition: opacity 0.2s;
        }

        .copy-icon {
          opacity: 0.5;
        }

        .check-icon {
          opacity: 0;
        }
      }
    }
  `]
})
export class CopyTextModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, text: string }) {}

  copyToClipboard(value: string): void {
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    selBox.value = value
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand('copy')
    document.body.removeChild(selBox)
  }
} 

